import type { MentorsCardProps } from "../_model";
import SmsIcon from "../assets/icons/sms.svg";
import LinkedInIcon from "../assets/icons/LinkedIn.svg";
import TwitterIcon from "../assets/icons/Twitter.svg";
import { global } from ":shared/app";

export function MentorsCard(props: MentorsCardProps) {
  function handleBooKSession() {
    global.store.actions.popop.pushModal({
      title: props.name,
      element: () => <iframe src={props.calendly} class="w-full h-full" />,
    });
  }

  return (
    <section class="relative w-full h-300px flex flex-col rounded-xl bg-bg px-3 pt-2 overflow-hidden border-border-card border-1 border-solid <sm:(h-350px)">
      <div class="flex flex-row w-full min-h-45% gap-x-2 overflow-hidden <sm:(w-full min-h-45%)">
        <div class="flex min-w-35% w-30% h-full rounded-full overflow-hidden <sm:(!min-w-50% w-50%)">
          <img class="w-full h-full object-cover" src={props?.image ?? "/images/placeholders/person.png"} alt="img" />
        </div>
        <div class="flex flex-col min-w-full w-full h-full gap-y-2">
          <p class="w-65% h-60% font-bold text-18px py-1 overflow-hidden overflow-ellipsis whitespace-normal <sm:(w-45%)">
            {props?.name ?? "No Name"}
          </p>
          <p class="w-fit h-fit  text-14px py-1 px-2 rounded-full bg-brand-alt text-brand text-start capitalize">
            {props?.track ?? "No track"}
          </p>

          <div class="flex justify-start items-center gap-2 ">
            <a href={`mailto:${props?.email}`}>
              <SmsIcon class="bg-brand px-5px rounded-sm w-27px h-27px" />
            </a>
            <a href={props?.twitter} target="_blank">
              <TwitterIcon class="bg-brand px-5px rounded-sm w-27px h-27px" />
            </a>
            <a href={props?.linkedin} target="_blank">
              <LinkedInIcon class="bg-brand px-5px rounded-sm w-27px h-27px" />
            </a>
          </div>
        </div>
      </div>
      <p class=" w-full text-14px px-1 h-full  text-text-alt text-start py-2 overflow-auto scrollbar">{props?.bio}</p>
      <button onClick={handleBooKSession} class="form-btn">
        Book session
      </button>
    </section>
  );
}
